import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../../help/scrap-tracking.mdx";

export function ScrapTrackingHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
